/** Routes that benefit from a collapsed sidebar on laptop-width viewports. */
export const DATA_DENSE_ROUTE_PREFIXES = [
  '/app/contacts',
  '/app/phone-numbers',
  '/app/outbound/campaigns',
  '/app/replies',
  '/app/sequences',
  '/app/sending',
  '/app/email-accounts',
] as const;

/** Routes that own the viewport (master-detail / workspace) — main must not page-scroll. */
export const FILL_VIEWPORT_ROUTE_PREFIXES = [
  '/app/replies',
  '/app/outbound/quick-call',
] as const;

export function isDataDenseRoute(pathname: string): boolean {
  if (pathname === '/app/inbound') return true;
  return DATA_DENSE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function isFillViewportRoute(pathname: string): boolean {
  if (pathname === '/app/inbound/new') return true;
  return FILL_VIEWPORT_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/** Sequence editor. The campaigns list on the same path keeps the trial strip. */
export function isCampaignBuilderPath(pathname: string, search: string): boolean {
  if (pathname !== '/app/outbound/campaigns') return false;
  const q = new URLSearchParams(search);
  return q.has('edit') || q.get('tab') === 'builder';
}
